export const styles = {
  container: {
    px: "11.2rem",
    pt: "4.8rem",
    pb: 0,
    width: "100%",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    background:
      "linear-gradient(245deg, var(--neutral-100) 41.78%, var(--cream-100) 81.88%)",
    flexDirection: { xs: "column", md: "row" },
    mt: { xs: "2rem", sm: "0rem" },
  },

  mobileImageContainer: {
    "& > img": {
      width: "34.4rem",
      height: "47.3511rem",
    },
  },

  textContainer: {
    width: "59.2rem",
  },

  downloadAppNowTitle: {
    "& h4": {
      color: "var(--black-900)",
      fontSize: "3.6rem",
      fontWeight: 500,
    },
  },

  appDescription: {
    mt: "2.4rem",
    mb: "2.4rem",
    color: "var(--gray-600)",
    fontSize: "1.4rem",
    fontWeight: 400,
  },

  getAppDownloadLink: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    width: "100%",
    mb: "2.4rem",
    "& > div > div": {
      width: "38rem",
      "& > input": {
        borderRadius: "0.8rem",
        outline: "0.1rem solid var(--gray-200)",
        background: "var(--neutral-100)",
      },
    },
    "& > button": {
      width: "20rem",
      ml: { xs: 0, sm: "1.6rem" },
      px: 0,
      py: "2.9rem",
      mt: { xs: "1.6rem", sm: 0 },
    },
  },

  downloadBtnContainer: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    gap: "2.4rem",
    "& > button": {
      cursor: "pointer",
      p: "0.8rem 1.2rem",
      display: "flex",
      alignItems: "center",
      width: "22.5rem",
      borderRadius: "0.8rem",
      backgroundColor: "var(--black-900)",
      border: "0.1rem solid var(--black-900)",
      color: "var(--neutral-100)",
    },
  },

  playStoreIconContainer: {
    "& > button": {
      cursor: "pointer",
      p: "0.8rem 1.2rem",
      display: "flex",
      alignItems: "center",
      width: "22.5rem",
      borderRadius: "0.8rem",
      backgroundColor: "var(--black-900)",
      border: "0.1rem solid var(--black-900)",
      color: "var(--neutral-100)",
    },
  },

  downloadBtnText: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    ml: "0.8rem",
  },

  downloadTextHeader: {
    color: "var(--neutral-100)",
    fontSize: "1.2rem",
    fontWeight: 400,
  },

  downloadTextFooter: {
    color: "var(--neutral-100)",
    fontSize: "1.6rem",
    fontWeight: 500,
  },
};
